// removed by extract-text-webpack-plugin
module.exports = {"container":"K8XTspZ6TaVr-aBfRtFj-","IconTrailing":"lssNUSLLXbNE7ywPco3kl","Icon":"_2i2Gg9PUKNDUmp4AMqpwV0","Name":"_3hQVXjuKKIxFgVLbMXSg1x","Button":"_1pA-t4CTwgxC5MAC8qKo2w","Email":"DtwNffeQ57khpV4ev_x8Z","verify":"_20_TYTxv-9nezi2vRUQlOr","Signer":"_1cyWJ83hYbCagxC0iATXWy"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/DocumentVerify/Main/Verify/styles.css
// module id = 2999
// module chunks = 0